import { persistentReducedStream } from '@ardoq/rxbeach';
import { defaultState, reducers } from './reducers';

const metamodelNavigation$ = persistentReducedStream(
  'metamodelNavigation$',
  defaultState,
  reducers
);

export { metamodelNavigation$ };
